"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.getDisplayName = function (Component) {
    if (typeof Component === 'string') {
        return Component;
    }
    if (!Component) {
        return undefined;
    }
    return Component.displayName || Component.name || 'Component';
};
exports.ensureHooks = function () {
    if (typeof react_1.default.useContext === 'undefined') {
        throw new Error('hooks are not supported in this react version');
    }
};
//# sourceMappingURL=utils.js.map


// WEBPACK FOOTER //
// ../src/utils.ts